import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BokkzVpbDataService, BokkzVpbLogic, VpbAangifte} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder} from "@angular/forms";

@Component({
  selector:
    'snelstart-venture-fiscaal-feature-tekst-samenstelling-fiscale-eenheid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-samenstelling-fiscale-eenheid.component.html',
  styleUrl: './tekst-samenstelling-fiscale-eenheid.component.scss',
})
export class TekstSamenstellingFiscaleEenheidComponent implements OnInit {

  @Input() public id!: string;
  public vpbAangifte = <VpbAangifte>{};
  public focusedElementId: string | null = null;
  public year = 2024;

  constructor(
      public dataService: BokkzVpbDataService,
      public vpbService: BokkzVpbLogic,
      private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.dataService.corporateTaxEntity.subscribe((value)=> {
      if (value.year !== undefined) {
        this.year = value.year;
      }
    })
  }

}

